import React from "react";

import "./style.scss";

export default ({ text }) => (
  <div className="project-header-container no-select">
    <span className="project-header-text">{text}</span>
  </div>
);
